// src/components/Footer.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Use Link for internal SPA rendering
import styles from "./Footer.module.css";

const Footer = () => {
  const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
  const [legalLinks, setLegalLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLegalDocs = async () => {
      try {
        const targetSlugs = ["privacy", "terms", "disclaimer"];
        const fetchedDocs = [];

        for (const slug of targetSlugs) {
          try {
            const response = await fetch(`${API_BASE}/api/legal/${slug}/`);
            if (response.ok) {
              const data = await response.json();
              fetchedDocs.push({
                name: data.title,
                path: `/legal/${data.slug}` // Points to your React Frontend layout
              });
            }
          } catch (error) {
            console.error(`Error loading slug "${slug}":`, error);
          }
        }
        setLegalLinks(fetchedDocs);
      } catch (error) {
        console.error("Error managing legal documents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLegalDocs();
  }, [API_BASE]);

  if (loading) return null;

  return (
    <footer className={styles.footer}>
      <div className={styles.topBorder} />
      <div className={`container ${styles.container}`}>
        {/* ... (Your existing Brand and Social sections remain exactly the same) ... */}
        
        <div className={styles.divider} />

        <div className={styles.bottomRow}>
          <div className={styles.legalLinks}>
            {legalLinks.map((link, idx) => (
              <React.Fragment key={link.name}>
                {/* Clean internal routing */}
                <Link to={link.path} className={styles.legalLink}>
                  {link.name}
                </Link>
                {idx < legalLinks.length - 1 && (
                  <span className={styles.legalSep}>·</span>
                )}
              </React.Fragment>
            ))}
          </div>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} Nulek. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;